import * as Yup from "yup";

export const SUB_ISSUE_MAP = {
  PROPERTY_GROUNDS: [
    {
      value: "DECK_REPAIR",
      label: "Deck Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GATE_REPAIR_INSTALL",
      label: "Gate Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "FENCE_REPAIR_INSTALL",
      label: "Fence Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GUTTER_CLEANING",
      label: "Gutter Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GUTTER_REPAIR_INSTALL",
      label: "Gutter Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DRIVEWAY_SIDEWALK",
      label: "Driveway/Sidewalk",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PRESSURE_WASHING",
      label: "Pressure Washing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CONCRETE_STONEWORK",
      label: "Concrete/Stonework",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LAWN_CARE",
      label: "Lawn Care",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "TREE_PRUNING_REMOVAL",
      label: "Tree Pruning/Removal",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LANDSCAPNG_SHRUBBERY",
      label: "Landscaping/Shrubbery",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SNOW_REMOVAL",
      label: "Snow Removal",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "IRRIGATION_REPAIR",
      label: "Irrigation Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LINE_STRIPING_AND_MARKING",
      label: "Line Striping and Marking",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SPRINKLER_BOWOUT",
      label: "Sprinkler Blowout",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SEASONAL_YARD_CLEAN_UP",
      label: "Seasonal Yard Clean Up",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PET_WASTE_REMOVAL",
      label: "Pet Waste Removal",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  PLUMBING: [
    {
      value: "DRAIN_CLEANING",
      label: "Drain Cleaning",
      priceRange: "$150 - $700",
    },
    {
      value: "FAUCET_REPAIR_INSTALL",
      label: "Faucet Repair/Install",
      priceRange: "$150 - $500",
    },
    {
      value: "GARBAGE_DISPOSAL_REPAIR_INSTALL",
      label: "Garbage Disposal Repair/Install",
      priceRange: "$150 - $650",
    },
    {
      value: "GAS_LEAK",
      label: "Gas Leak",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GAS_LINE_REPAIR_INSTALL",
      label: "Gas Line Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LEAK_DETECTION_AND_REPAIR",
      label: "Leak Detection and Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PIPE_REPAIR_INSTALL",
      label: "Pipe Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PLUMBING_REPAIR_INSTALL",
      label: "Plumbing Repair/Install",
      priceRange: "$250 - $1,000",
    },
    {
      value: "SEPTIC_SYSTEM_PUMPING",
      label: "Septic System Pumping",
      priceRange: "$500 - $800",
    },
    {
      value: "SEPTIC_SYSTEM_SERVICES",
      label: "Septic System Services",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BOILER_REPAIR_INSTALL",
      label: "Boiler Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "TOILET_REPAIR",
      label: "Toilet Repair",
      priceRange: "$150 - $350",
    },
    {
      value: "TOILET_INSTALL",
      label: "Toilet Install",
      priceRange: "$350 - $800",
    },
    {
      value: "SHOWER_BATH_HARDWARE_REPAIR",
      label: "Shower/Bath Hardware Repair",
      priceRange: "$150 - $500",
    },
    {
      value: "SHOWER_BATH_INSTALL",
      label: "Shower/Bath Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  ELECTRICAL: [
    {
      value: "CIRCUIT_BREAKER_REPAIR_INSTALL",
      label: "Circuit Breaker Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ELECTRICAL_REPAIR_INSTALL",
      label: "Electrical Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ELECTRICAL_PANEL_UPGRADES",
      label: "Electrical Panel Upgrades",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ELECTRICAL_TROUBLESHOOTING",
      label: "Electrical Troubleshooting",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "INTERIOR_LIGHTING",
      label: "Interior Lighting",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "EXTERIOR_LIGHTING",
      label: "Exterior Lighting",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LIGHTING_FIXTURE_REPAIR_INSTALL",
      label: "Lighting Fixture Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OUTLET_REPAIR_INSTALL",
      label: "Outlet Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LIGHT_SWITCH_REPAIR_INSTALL",
      label: "Light Switch Repair/Install",
      priceRange: "$150 - $500",
    },
    {
      value: "WIRING_REPAIR_INSTALL",
      label: "Wiring Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  HVAC: [
    {
      value: "THERMOSTAT_REPAIR_INSTALL",
      label: "Thermostat Repair/Install",
      priceRange: "$150 - $500",
    },
    {
      value: "AIR_CONDITIONING_REPAIR_INSTALL",
      label: "Air Conditioning Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "AIR_CONDITIONING_MAINTENANCE",
      label: "Air Conditioning Maintenance",
      priceRange: "$150 - $400",
    },
    {
      value: "AIR_QUALITY_TESTING",
      label: "Air Quality Testing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BOILER_REPAIR_INSTALL",
      label: "Boiler Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "AIR_FILTER_CLEANING_REPLACEMENT",
      label: "Air Filter Cleaning/Replacement",
      priceRange: "$100 - $250",
    },
    {
      value: "DUCTLESS_MINI_SPLIT_SYSTEM_REPAIR_INSTALL",
      label: "Ductless Mini-Split System Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DUCTWORK_CLEANING",
      label: "Ductwork Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DUCTWORK_REPAIR_INSTALL",
      label: "Ductwork Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "FURNACE_REPAIR_INSTALL",
      label: "Furnace Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "HEATER_REPAIR",
      label: "Heater Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "RADIATOR_REPAIR",
      label: "Radiator Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "HUMIDIFIER",
      label: "Humidifier",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "VENT_CLEANING_INSTALL",
      label: "Vent Cleaning/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "RADIANT_HEATING_REPAIR_INSTALL",
      label: "Radiant Heating Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  APPLIANCES: [
    {
      value: "APPLIANCE_MAINTENANCE",
      label: "Appliance Maintenance",
      priceRange: "$150 - $400",
    },
    {
      value: "GAS_APPLIANCE_REPAIR_INSTALL_MAINTENANCE",
      label: "Gas Appliance Repair/Install/Maintenance",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "APPLIANCE_REMOVAL_DISPOSAL",
      label: "Appliance Removal & Disposal",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "REFRIDGERATOR_FREEZER_REPAIR_INSTALL",
      label: "Refrigerator/Freezer Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ICE_MAKER_REPAIR",
      label: "Ice Maker Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "MICROWAVE_REPAIR_INSTALL",
      label: "Microwave Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OVEN_REPAIR_INSTALL",
      label: "Oven Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "RANGE_HOOD_REPAIR_INSTALL",
      label: "Range Hood Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "STOVE_REPAIR_INSTALL",
      label: "Stove Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "WASHING_MACHINE_REPAIR_INSTALL",
      label: "Washing Machine Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DRYER_REPAIR_INSTALL",
      label: "Dryer Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "WATERLINE_TO_APPLIANCES_REPAIR",
      label: "Waterline to Appliances Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  DOORS_WINDOWS: [
    {
      value: "ANDERSON_WINDOW_AND_DOOR_REPAIR_INSTALL",
      label: "Anderson Window & Door Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "AUTOMATIC_DOOR_REPAIR_INSTALL",
      label: "Automatic Door Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BAY_WINDOW_REPAIR",
      label: "Bay Window Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BOW_WINDOW_REPAIR",
      label: "Bow Window Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CASEMENT_WINDOW_REPAIR",
      label: "Casement Window Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CLOSET_DOOR_REPAIR_INSTALL",
      label: "Closet Door Repair/Install",
      priceRange: "$200 - $750",
    },
    {
      value: "CABINET_DOOR_REPAIR",
      label: "Cabinet Door Repair",
      priceRange: "$100 - $400",
    },
    {
      value: "DOOR_FINISHING_AND_STAINING",
      label: "Door Finishing and Staining",
      priceRange: "$200 - $700",
    },
    {
      value: "DOOR_FRAME_REPAIR",
      label: "Door Frame Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DOOR_HARDWARE_REPAIR",
      label: "Door Hardware Repair",
      priceRange: "$150 - $350",
    },
    {
      value: "DOOR_HINGE_REPAIR",
      label: "Door Hinge Repair",
      priceRange: "$150 - $350",
    },
    {
      value: "DOOR_LOCK_REPAIR",
      label: "Door Lock Repair",
      priceRange: "$150 - $400",
    },
    {
      value: "DOOR_REPLACEMENT",
      label: "Door Replacement",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DOOR_SCREEN_REPAIR_INSTALL",
      label: "Door Screen Repair/Install",
      priceRange: "$150 - $550",
    },
    {
      value: "SLIDING_DOOR_REPAIR_INSTALL",
      label: "Sliding Door Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "WINDOW_REPAIR_INSTALL",
      label: "Window Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "STORM_DOOR_REPAIR_INSTALL",
      label: "Storm Door Repair/Install",
      priceRange: "$250 - $1,000",
    },
    {
      value: "WINDOW_AND_DOOR_INSULATION",
      label: "Window & Door Insulation",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_HARDWARE_REPAIR",
      label: "Garage Door Hardware Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_MOTOR_REPAIR_INSTALL",
      label: "Garage Door Motor Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_OPENER_REPAIR_INSTALL",
      label: "Garage Door Opener Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_REPAIR_INSTALL",
      label: "Garage Door Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_REALIGNMENT",
      label: "Garage Door Realignment",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_SPRING_REPLACEMENT",
      label: "Garage Door Spring Replacement",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_SENSOR_REPLACEMENT",
      label: "Garage Door Sensor Replacement",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GARAGE_DOOR_TRACK_REPAIR_INSTALL",
      label: "Garage Door Track Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  LOCKSMITH: [
    {
      value: "DEADBOLT_REPAIR_INSTALL",
      label: "Deadbolt Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ELECTRONIC_LOCK_REPAIR_INSTALL",
      label: "Electronic Lock Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "HIGH_SECURITY_LOCKS",
      label: "High Security Locks",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "KEY_REPLACEMENTS",
      label: "Key Replacements",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LOCK_REPAIR_INSTALL",
      label: "Lock Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LOCKOUT_SERVICES",
      label: "Lockout Services",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SAFE_CRACKING",
      label: "Safe Cracking",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  GENERAL_MAINTENANCE: [
    {
      value: "ATTIC_VENT_REPAIR_INSTALL",
      label: "Attic Vent Repair/Install",
      priceRange: "$150 - $500",
    },
    {
      value: "SMALL_CARPENTRY_WORK",
      label: "Small Carpentry Work",
      priceRange: "$150 - $600",
    },
    {
      value: "CAULKING_SEALING",
      label: "Caulking & Sealing",
      priceRange: "$150 - $400",
    },
    {
      value: "CEILING_FAN_REPAIR_INSTALL",
      label: "Ceiling Fan Repair/Install",
      priceRange: "$150 - $600",
    },
    {
      value: "WINDOW_SHADE_REPAIR_INSTALL",
      label: "Window Shade Repair/Install",
      priceRange: "$150 - $400",
    },
    {
      value: "DECK_REPAIR_INSTALL",
      label: "Deck Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DRYWALL_REPAIR",
      label: "Drywall Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DRYWALL_PATCHING",
      label: "Drywall Patching",
      priceRange: "$100 - $300",
    },
    {
      value: "ELECTRICAL_REPAIRS",
      label: "Electrical Repairs",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "FENCE_REPAIR_INSTALL",
      label: "Fence Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LIGHTING_FIXTURE_REPAIR_INSTALL",
      label: "Lighting Fixture Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "FAUCET_REPAIR_INSTALL_100_500",
      label: "Faucet Repair/Install",
      priceRange: "$100 - $500",
    },
    {
      value: "FURNITURE_ASSEMBLY",
      label: "Furniture Assembly",
      priceRange: "$100 - $500",
    },
    {
      value: "GRAB_BAR_REPAIR_INSTALL",
      label: "Grab Bar Repair/Install",
      priceRange: "$100 - $400",
    },
    {
      value: "INTERIOR_PAINTING_STAINING",
      label: "Interior Painting/Staining",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "EXTERIOR_PAINTING_STAINING",
      label: "Exterior Painting/Staining",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "LOCK_AND_HANDLE_REPAIR_INSTALL",
      label: "Lock and Handle Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SMALL_DEMOLITION_PROJECT",
      label: "Small Demolition Project",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SMALL_ROOF_REPAIR_INSTALL",
      label: "Small Roof Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SMOKE_DETECTOR_REPLACEMENT",
      label: "Smoke Detector Replacement",
      priceRange: "$100 - $300",
    },
    {
      value: "TILE_REPAIR_INSTALL",
      label: "Tile Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "TOILET_REPAIR",
      label: "Toilet Repair",
      priceRange: "$150 - $350",
    },
    {
      value: "TV_MOUNTING",
      label: "TV Mounting",
      priceRange: "$100 - $400",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  FLOORING: [
    {
      value: "WOOD_FLOORING_REPAIR_INSTALL",
      label: "Wood Flooring Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CARPET_FLOORING_REPAIR_INSTALL",
      label: "Carpet Flooring Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "VINYL_FLOORING_REPAIR_INSTALL",
      label: "Vinyl Flooring Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "TILE_FLOORING_REPAIR_INSTALL",
      label: "Tile Flooring Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "RADIANT_HEATING_REPAIR_INSTALL",
      label: "Radiant Heating Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  PAINTING: [
    {
      value: "INTERIOR_PAINTING_STAINING",
      label: "Interior Painting/Staining",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "EXTERIOR_PAINTING_STAINING",
      label: "Exterior Painting/Staining",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CABINET_PAINTING_STAINING",
      label: "Cabinet Painting/Staining",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  PEST_CONTROL: [
    {
      value: "ANT_CONTROL",
      label: "Ant Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BED_BUG_EXTERMINATION",
      label: "Bed Bug Extermination",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BEE_AND_WASP_REMOVAL",
      label: "Bee and Wasp Removal",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BIRD_CONTROL",
      label: "Bird Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BAT_REMOVAL",
      label: "Bat Removal",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "COCKROACH_CONTROL",
      label: "Cockroach Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ECO_FRIENDLY_PEST_CONTROL",
      label: "Eco Friendly Pest Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "MICE_AND_RAT_CONTROL",
      label: "Mice and Rat Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "MOSQUITO_CONTROL",
      label: "Mosquito Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PEST_EXTERMINATION",
      label: "Pest Extermination",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PEST_PREVENTION",
      label: "Pest Prevention",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PEST_PROOFING_AND_SEALING",
      label: "Pest Proofing and Sealing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "RODENT_CONTROL",
      label: "Rodent Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SPIDER_CONTROL",
      label: "Spider Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "TERMITE_CONTROL",
      label: "Termite Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "WILDLIFE_CONTROL",
      label: "Wildlife Control",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  EXTERIOR: [
    {
      value: "SIDING_AND_TRIM_REPAIR",
      label: "Siding and Trim Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "WOOD_REPAIR_INSTALL",
      label: "Wood Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "STONE_REPAIR_INSTALL",
      label: "Stone Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BRICK_REPAIR_INSTALL",
      label: "Brick Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PAINTING_STAINING",
      label: "Painting/Staining",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ACCESS_CARD_AND_KEY_FOB_MAINTENANCE",
      label: "Access Card and Key Fob Maintenance",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SECURITY_SYSTEM_REPAIR_INSTALL",
      label: "Security System Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BUILDING_SIGNAGE",
      label: "Building Signage",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "STUCCO_REPAIR_INSTALL",
      label: "Stucco Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DRIVEWAY_SIDEWALK",
      label: "Driveway/Sidewalk",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PRESSURE_WASHING",
      label: "Pressure Washing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_CAP_REPAIR_INSTALL",
      label: "Chimney Cap Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_LINER_REPAIR_INSTALL",
      label: "Chimney Liner Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_REPAIR",
      label: "Chimney Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  ROOFING: [
    {
      value: "EAVES_AND_SOFFIT_REPAIRS",
      label: "Eaves & Soffit Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "FLASHING_AND_SEALING",
      label: "Flashing & Sealing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GUTTER_CLEANING",
      label: "Gutter Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GUTTER_REPAIR_INSTALL",
      label: "Gutter Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ASPHALT_ROOF_REPAIR_INSTALL",
      label: "Asphalt Roof Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CLAY_TILE_ROOF_REPAIR_INSTALL",
      label: "Clay Tile Roof Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "SLATE_ROOF_REPAIR_INSTALL",
      label: "Slate Roof Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "METAL_ROOF_REPAIR_INSTALL",
      label: "Metal Roof Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "EPDM_ROOF_REPAIR_INSTALL",
      label: "EPDM Roof Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ROOF_LEAK_REPAIR",
      label: "Roof Leak Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ROOF_MAINTENANCE_AND_CLEANING",
      label: "Roof Maintenance & Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "ROOF_STORM_DAMAGE_REPAIR_INSTALL",
      label: "Roof Storm Damage Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_CAP_REPAIR_INSTALL",
      label: "Chimney Cap Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_LINER_REPAIR_INSTALL",
      label: "Chimney Liner Repair/Install",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_REPAIR",
      label: "Chimney Repair",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
  CLEANING: [
    {
      value: "AIR_DUCT_CLEANING",
      label: "Air Duct Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "BIOHAZARD_CLEANUP",
      label: "Biohazard Cleanup",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CARPET_CLEANING",
      label: "Carpet Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "DISINFECTION_AND_SANITIZATION",
      label: "Disinfection & Sanitization",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "FLOOR_CLEANING",
      label: "Floor Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GENERAL_CLEANING",
      label: "General Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "GUTTER_CLEANING",
      label: "Gutter Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "JUNK_REMOVAL_SERVICES",
      label: "Junk Removal Services",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "MOVE_IN_AND_MOVE_OUT_CLEANING",
      label: "Move-in & Move-out Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "PRESSURE_WASHING",
      label: "Pressure Washing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "TILE_AND_GROUT_CLEANING",
      label: "Tile and Grout Cleaning",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "WINDOW_WASHING",
      label: "Window Washing",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "MOLD_REMEDIATION",
      label: "Mold Remediation",
      priceRange: "Price varies - Onsite evaluation required",
    },
    {
      value: "CHIMNEY_SWEEP_CLEANING",
      label: "Chimney Sweep Cleaning",
      priceRange: "$150 - $400",
    },
    {
      value: "OTHER",
      label: "Other",
      priceRange: "Price varies - Onsite evaluation required",
    },
  ],
};

export const initialValues = {
  request_type: "",
  name: "",
  phone_number: "",
  email: "",
  created_by: "",
  account_type: "",

  property: "",
  property_label: "",
  unit: "",
  unit_label: "",
  issue_type: "",
  sub_issue_type: "",
  media_files: null,
  description: "",
  price_estimate: "",

  available_from: "",
  available_to: "",
  days_available: [],

  can_enter_without_presence: false,
  can_enter_details: "",

  has_pets: false,
  pet_details: "",

  access_instructions: "",

  has_access_info: false,
  access_details: "",
};

export const formFields = {
  step1: {
    tenant_name: {
      label: "Tenant / Owner Name:",
      placeholder: "Enter Tenant Name",
      startIcon: "👤",
      type: "text",
      name: "name",
    },
    phone_number: {
      label: "Phone Number",
      placeholder: "Enter Tenant Phone Number",
      startIcon: "📱",
      type: "text",
      name: "phone_number",
    },
    tenant_email: {
      label: "Email Address",
      placeholder: "Enter Tenant Email Address",
      startIcon: "📧",
      type: "email",
      name: "email",
    },
  },
  step2: {
    property: {
      label: "Property Address",
      placeholder: "Select a property",
      startIcon: "🏠",
      type: "select",
      name: "property",
      options: [], // This would be populated with actual property data
    },
  },
  step3: {
    issue_type: {
      label: "Issue Type",
      placeholder: "Select issue type",
      startIcon: "🔧",
      type: "select",
      name: "issue_type",
      options: [
        { value: "PROPERTY_GROUNDS", label: "Property Grounds" },
        { value: "PLUMBING", label: "Plumbing" },
        { value: "ELECTRICAL", label: "Electrical" },
        { value: "HVAC", label: "HVAC" },
        { value: "APPLIANCES", label: "Appliances" },
        { value: "DOORS_WINDOWS", label: "Window & Door" },
        { value: "LOCKSMITH", label: "Locksmith" },
        { value: "GENERAL_MAINTENANCE", label: "General Maintenance" },
        { value: "FLOORING", label: "Flooring" },
        { value: "PAINTING", label: "Painting" },
        { value: "PEST_CONTROL", label: "Pest Control" },
        { value: "EXTERIOR", label: "Exterior" },
        { value: "ROOFING", label: "Roofing" },
        { value: "CLEANING", label: "Cleaning" },
      ],
    },
  },
  step4: {
    sub_issue_type: {
      label: "Sub Issue Type",
      placeholder: "Select sub issue type (optional)",
      startIcon: "🔍",
      type: "select",
      name: "sub_issue_type",
      options: [
        { value: "leak", label: "Leak" },
        { value: "clogged", label: "Clogged" },
        { value: "broken", label: "Broken" },
        { value: "malfunctioning", label: "Malfunctioning" },
        { value: "other", label: "Other" },
      ],
    },
    media_files: {
      label: "Upload Media",
      placeholder: "Upload photos or videos (optional)",
      startIcon: "📷",
      type: "file",
      name: "media_files",
      accept: "image/*,video/*",
    },
    description: {
      label: "Description",
      placeholder: "Enter a brief description of the issue",
      startIcon: "📝",
      type: "textarea",
      name: "description",
    },
    price_estimate: {
      label: "Price Estimate",
      placeholder: "Enter your price estimate",
      startIcon: "💰",
      type: "text",
      name: "price_estimate",
    },
  },
  step5: {
    available_from: {
      label: "Available From",
      placeholder: "Select start date",
      startIcon: "📅",
      type: "date",
      name: "available_from",
    },
    available_to: {
      label: "Available To",
      placeholder: "Select end date",
      startIcon: "📅",
      type: "date",
      name: "available_to",
    },
    days_available: {
      label: "Days Available",
      placeholder: "Select available days",
      startIcon: "📆",
      type: "multiselect",
      name: "days_available",
      options: [
        { value: "monday", label: "Monday" },
        { value: "tuesday", label: "Tuesday" },
        { value: "wednesday", label: "Wednesday" },
        { value: "thursday", label: "Thursday" },
        { value: "friday", label: "Friday" },
        { value: "saturday", label: "Saturday" },
        { value: "sunday", label: "Sunday" },
      ],
    },
  },
  step6: {
    can_enter_without_presence: {
      label: "Can enter without presence",
      placeholder: "Select yes or no",
      startIcon: "📑",
      type: "toggle",
      name: "can_enter_without_presence",
    },
    can_enter_details: {
      label: "Entry Instructions",
      placeholder: "Provide details for entry (if any)",
      startIcon: "📝",
      type: "textarea",
      name: "can_enter_details",
    },
  },
  step7: {
    has_pets: {
      label: "Do you have pets?",
      placeholder: "Select yes or no",
      startIcon: "🐕",
      type: "toggle",
      name: "has_pets",
    },
    pet_details: {
      label: "Pet Details",
      placeholder: "Describe your pets (if any)",
      startIcon: "🐾",
      type: "textarea",
      name: "pet_details",
    },
  },
  step8: {
    access_instructions: {
      label: "Access Instructions",
      placeholder: "Provide any special access instructions",
      startIcon: "📝",
      type: "textarea",
      name: "access_instructions",
    },
  },
  step9: {
    has_access_info: {
      label:
        "Is there anything else we should be aware of when entering the property?",
      placeholder: "Select yes or no",
      startIcon: "ℹ️",
      type: "radio",
      name: "has_access_info",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    access_details: {
      label: "Tell us more?",
      placeholder: "Please provide additional access information...",
      startIcon: "📝",
      type: "textarea",
      name: "access_details",
      conditional: "has_access_info",
      conditional_value: true,
    },
  },
};

const startOfToday = new Date();
startOfToday.setHours(0, 0, 0, 0);

export const validationSchemas = {
  0: Yup.object().shape({
    request_type: Yup.string().required(
      "Please select one job type to continue"
    ),
  }),

  1: Yup.object().shape({
    name: Yup.string().required("Tenant name is required"),
    phone_number: Yup.string().optional(),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email address is required"),
  }),

  2: Yup.object().shape({
    property: Yup.number()
      .required("Property is required")
      .integer("Property ID must be an integer"),
    unit: Yup.number().when("account_type", {
      is: (account_type) =>
        account_type !== "HOMEOWNER" &&
        account_type !== "FAMILY_MEMBER" &&
        account_type !== "STR_HOST",
      then: (schema) =>
        schema
          .required("Unit is required")
          .integer("Unit ID must be an integer"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  }),

  3: Yup.object().shape({
    issue_type: Yup.string().required("Issue type is required"),
  }),

  4: Yup.object().shape({
    sub_issue_type: Yup.string().when("issue_type", {
      is: (issue_type) => issue_type && issue_type !== "",
      then: (schema) => schema.required("Please select a sub-issue type"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
    media_files: Yup.string().nullable().optional(),
    description: Yup.string().nullable().optional(),
    price_estimate: Yup.string().nullable().optional(),
  }),

  5: Yup.object().shape({
    available_from: Yup.date()
      .required("Start date is required")
      .min(startOfToday, "Start date cannot be in the past")
      .typeError("Please enter a valid date"),
    available_to: Yup.date()
      .required("End date is required")
      .min(Yup.ref("available_from"), "End date must be on or after start date")
      .typeError("Please enter a valid date"),
    days_available: Yup.array()
      .min(1, "Please select at least one time slot")
      .required("Please select at least one time slot"),
  }),

  6: Yup.object().shape({
    can_enter_without_presence: Yup.boolean().optional(),
    can_enter_details: Yup.string().when("can_enter_without_presence", {
      is: true,
      then: (schema) => schema.required("Please provide entry instructions"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  }),

  7: Yup.object().shape({
    has_pets: Yup.boolean().optional(),
    pet_details: Yup.string().when("has_pets", {
      is: true,
      then: (schema) => schema.required("Please provide details about your pets"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  }),

  8: Yup.object().shape({
    access_instructions: Yup.string().nullable().optional(),
  }),
  9: Yup.object().shape({
    has_access_info: Yup.boolean().optional(),
    access_details: Yup.string().nullable().optional(),
  }),
};
export const stepsNames = [
  "Select Job Type",
  "Confirm Contact Info",
  "Confirm Property Address",
  "Select Issue Type",
  "Describe the Specific Issue",
  "Select Your Availability",
  "Property Access Instructions",
  "Pet Instruction",
  "Additional Info",
];
export const Title = {
  0: {
    title: "Start a new request or set up a recurring task",
    subTitle:
      "You can submit a one-time maintenance request or create a recurring task for scheduled services like inspections or landscaping.",
  },
  1: {
    title: "Let's confirm some information first",
    subTitle:
      "",
  },
  2: {
    title: "Please confirm the address below is where you need work completed",
    subTitle: null
  },
  3: {
    title: "What seems to be the issue?",
    subTitle: `Choose the category that best describes the issue you're experiencing.`,
  },
  4: {
    title: "What specific issue are you experiencing?",
    subTitle:
      "Please select the specific type of issue you're dealing with. You can also upload a photo or video to help us assess the issue faster.",
  },
  5: {
    title: "Select all the time slots you are available",
    subTitle:
      "Choose all time slots when someone will be available at the property. If none of these times work, you can give access instead.",
  },
  6: {
    title: "Property Access",
    subTitle: "",
  },
  7: {
    title: "Pet Information",
    subTitle: "",
  },
  8: {
    title: "Additional Information",
    subTitle: "",
  },
  9: {
    title: "Your maintenance request has been submitted.",
    subTitle: "We'll keep you updated as the job moves forward",
  },
};

export const stepFieldsMap = {
  0: ["request_type"],
  1: ["name", "phone_number", "email"],
  2: ["property", "property_label", "unit", "unit_label"],
  3: ["issue_type"],
  4: ["sub_issue_type", "media_files", "description", "price_estimate"],
  5: ["available_from", "available_to", "days_available"],
  6: ["can_enter_without_presence", "can_enter_details"],
  7: ["has_pets", "pet_details"],
  8: ["access_instructions"],
  9: ["has_access_info", "access_details"],
};
